module.exports = __webpack_public_path__ + "img/message.ed22010a.svg";